<template>
  <div class="builder-desktop-view">
    <header-container :class="{ 'mb-5': editing }" />

    <div class="row">
      <div class="col-6 col-lg-8">
        <img
          src="@/assets/images/checkout-builder/checkout-desktop.svg"
          class="d-none d-lg-block"
        />
        <img
          src="@/assets/images/checkout-builder/checkout-responsive.svg"
          class="d-lg-none"
        />
      </div>
      <div
        class="col-6 d-flex col-lg-4 flex-column"
        :class="{ 'gap-5': editing }"
      >
        <img
          src="@/assets/images/checkout-builder/checkout-right-desktop.svg"
          class="d-none d-lg-block"
        />
        <img
          src="@/assets/images/checkout-builder/checkout-right-responsive.svg"
          class="d-lg-none"
        />

        <side-container class="flex-fill" />
      </div>
    </div>

    <footer-container :class="{ 'mt-5': editing }" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import FooterContainer from "../container/FooterContainer.vue";
import HeaderContainer from "../container/HeaderContainer.vue";
import SideContainer from "../container/SideContainer.vue";
export default {
  components: { HeaderContainer, SideContainer, FooterContainer },
  computed: {
    ...mapState("checkoutBuilder", ["editing"])
  }
};
</script>
